const publicRoots = ["/review", "/shared-report", "/shared/dashboards", "/verify", "/invite", "/reset"]

export function publicRegistrationEnabled() {
  return import.meta.env.VITE_PUBLIC_REGISTRATION === "true"
}

export function isPublicRoute(pathname: string) {
  return publicRoots.some((root) => pathname === root || pathname.startsWith(`${root}/`))
}

export function isStandaloneDashboardPreviewRoute(pathname: string) {
  return /^\/[^/]+\/dashboards\/[^/]+\/[^/]+\/preview\/[^/]+\/?$/.test(pathname)
}
